export default __webpack_public_path__ + "static/SRF Carasweet 5SGF7709 - Product Specifications & Technical Data-fff22de773a7c0c847db64e236a2b85e.pdf";